import React, { useState } from "react";
import "./FileUploadInput.scss"; // Import your SCSS file
import browseImage from "../../Assets/Images/BrowseFilesIcon.png";

const FileUploadInput = ({ setSelectedFile }) => {
  const [selectedFileNames, setSelectedFileNames] = useState([]);

  const openFileInput = () => {
    document.getElementById("fileInput").click();
  };

  const handleFileChange = (event) => {
    const fileList = event.target.files;
    const files = [];

    for (let i = 0; i < fileList.length; i++) {
      files.push({
        name: fileList[i].name,
        size: fileList[i].size,
      });
    }

    setSelectedFileNames((prevFiles) => [...prevFiles, ...files]);

    // Pass the selected file to the parent component
    if (fileList.length > 0) {
      setSelectedFile(fileList[0]);
    }
  };

  const formatFileSize = (size) => {
    const units = ["B", "KB", "MB", "GB"];
    let index = 0;

    while (size >= 1024 && index < units.length - 1) {
      size /= 1024;
      index++;
    }

    return `${size.toFixed(2)} ${units[index]}`;
  };

  const removeFile = (index) => {
    setSelectedFileNames((prevFiles) =>
      prevFiles.filter((file, i) => i !== index)
    );
    setSelectedFile(null);
  };

  return (
    <div id="app">
      <div className="">
        <div className="file-input-box">
          <div className="wrapper-file-input">
            <div className="input-box" onClick={openFileInput}>
              <div className="d-flex">
                <div className="d-flex flex-column">
                  <div>
                    <img src={browseImage} className="img-fluid" alt="selected" />
                  </div>
                  <div></div>
                </div>
                <div className="d-flex flex-column">
                  <div className="fs-5 fw-normal">
                    Select a file or drag and drop here
                  </div>
                  <div className="fs-6 text-black-50">
                    JPG or PNG file size no more than 10MB
                  </div>
                </div>
              </div>
              <div className="d-flex ms-auto justify-content-end">
                {/* <button className="btn btn-default border rounded-5 px-4 border-success text-success">
                  Browse files
                </button> */}
              </div>

              <input
                id="fileInput"
                type="file"
                hidden
                onChange={handleFileChange}
                multiple
              />
            </div>
          </div>

          <div className="wrapper-file-section pt-4">
            <div className="selected-files">
              <h6>Selected Files</h6>
              <ul className="file-list">
                {selectedFileNames.map((f, index) => (
                  <li key={index} className="item">
                    <span className="name">
                      {f.name} ({formatFileSize(f.size)})
                    </span>
                    <div className="remove" onClick={() => removeFile(index)}>
                      <i className="fa fa-trash fs-4"></i>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUploadInput;
